// Animated marquee wall of typographic brand wordmarks. Two rows scroll in
// opposite directions. Names remain trademarks of their respective owners.

type Brand = {
  name: string;
  display?: string;
  className: string;
};

const brands: Brand[] = [
  { name: "GE",            display: "GE",             className: "font-serif italic font-bold tracking-tight text-[1.5rem]" },
  { name: "GE Profile",    display: "GE Profile",     className: "font-serif italic font-semibold tracking-tight" },
  { name: "Café",          display: "Café",           className: "font-serif italic text-[1.4rem]" },
  { name: "Monogram",      display: "MONOGRAM",       className: "font-light tracking-[0.35em] text-[0.8rem]" },
  { name: "Samsung",       display: "SAMSUNG",        className: "font-bold tracking-[0.18em]" },
  { name: "LG",            display: "LG",             className: "font-bold tracking-tight text-[1.6rem]" },
  { name: "Whirlpool",     display: "Whirlpool",      className: "font-semibold italic tracking-tight text-[1.1rem]" },
  { name: "Kenmore",       display: "Kenmore",        className: "font-bold tracking-tight" },
  { name: "KitchenAid",    display: "KitchenAid",     className: "font-extrabold tracking-tight" },
  { name: "Frigidaire",    display: "Frigidaire",     className: "font-serif font-semibold tracking-wide" },
  { name: "Bosch",         display: "BOSCH",          className: "font-extrabold tracking-[0.22em]" },
  { name: "Maytag",        display: "MAYTAG",         className: "font-black tracking-[0.15em]" },
  { name: "Amana",         display: "amana",          className: "font-light tracking-[0.3em] lowercase text-[1.1rem]" },
  { name: "Electrolux",    display: "Electrolux",     className: "font-light tracking-[0.18em]" },
  { name: "Sub-Zero",      display: "SUB·ZERO",       className: "font-serif font-semibold tracking-[0.2em]" },
  { name: "Wolf",          display: "WOLF",           className: "font-serif font-bold tracking-[0.3em]" },
  { name: "Viking",        display: "VIKING",         className: "font-black tracking-[0.25em]" },
  { name: "Thermador",     display: "THERMADOR",      className: "font-light tracking-[0.32em] text-[0.8rem]" },
  { name: "Miele",         display: "Miele",          className: "font-serif font-bold tracking-tight text-[1.2rem]" },
  { name: "Fisher & Paykel", display: "Fisher & Paykel", className: "font-light tracking-wide text-[0.9rem]" },
  { name: "Jenn-Air",      display: "JENN-AIR",       className: "font-bold tracking-[0.18em]" },
  { name: "Hotpoint",      display: "Hotpoint",       className: "font-serif italic font-semibold tracking-tight text-[1.1rem]" },
  { name: "Speed Queen",   display: "Speed Queen",    className: "font-extrabold italic tracking-tight" },
  { name: "Dacor",         display: "DACOR",          className: "font-serif tracking-[0.35em]" },
  { name: "Asko",          display: "ASKO",           className: "font-light tracking-[0.4em]" },
  { name: "DCS",           display: "DCS",            className: "font-black tracking-[0.2em] text-[1.5rem]" },
  { name: "Smeg",          display: "Smeg",           className: "font-serif italic font-bold text-[1.4rem]" },
  { name: "Bertazzoni",    display: "Bertazzoni",     className: "font-serif tracking-wide" },
  { name: "Haier",         display: "Haier",          className: "font-bold tracking-tight text-[1.2rem]" },
  { name: "Insignia",      display: "INSIGNIA",       className: "font-semibold tracking-[0.22em]" },
  { name: "Magic Chef",    display: "Magic Chef",     className: "font-serif italic font-semibold" },
  { name: "Roper",         display: "ROPER",          className: "font-extrabold tracking-[0.2em]" },
  { name: "Tappan",        display: "Tappan",         className: "font-serif font-semibold tracking-wide text-[1.05rem]" },
];

const mid = Math.ceil(brands.length / 2);
const rowA = brands.slice(0, mid);
const rowB = brands.slice(mid);

function Pill({ b }: { b: Brand }) {
  return (
    <div
      className="glass mx-2 flex h-14 shrink-0 items-center justify-center rounded-full px-5"
      title={b.name}
    >
      <span
        className={`select-none whitespace-nowrap text-foreground/80 transition-colors duration-300 hover:text-primary ${b.className}`}
        aria-label={b.name}
      >
        {b.display ?? b.name}
      </span>
    </div>
  );
}

function Row({ items, direction }: { items: Brand[]; direction: "left" | "right" }) {
  const animClass = direction === "left" ? "animate-marquee-left" : "animate-marquee-right";
  return (
    <div className="marquee-track overflow-hidden">
      <div className={`marquee-row flex w-max ${animClass}`}>
        {[...items, ...items].map((b, i) => (
          <Pill key={`${b.name}-${i}`} b={b} />
        ))}
      </div>
    </div>
  );
}

export function BrandWall() {
  return (
    <div className="space-y-3">
      <div className="marquee-mask space-y-3">
        <Row items={rowA} direction="left" />
        <Row items={rowB} direction="right" />
      </div>
      <p className="text-center text-[10px] leading-relaxed text-muted-foreground">
        All brand names are trademarks of their respective owners. StillFusion LLC
        is an independent service provider and is not affiliated with these brands.
      </p>
    </div>
  );
}
